import type { ReactElement } from 'react';
import './PeopleLine.css';

/**
 * "N people have stood here" (v4.0 §4.17) — the one public number a light
 * carries. The count is always a numeral and set apart from the sentence, so
 * the eye lands on it first wherever the line appears: on the tag under a
 * light, on a place page, on the Result's seals. The surface sets its colour.
 */
export function PeopleLine({ count }: { count: number }): ReactElement {
  if (count <= 0) return <>The first light here</>;
  return (
    <>
      <b className="people-count">{count.toLocaleString('en-US')}</b>
      {count === 1 ? ' person has stood here' : ' people have stood here'}
    </>
  );
}
